import React from 'react';

import { ClauseText, DangerText } from './Components/ContractText';

interface Props {
  propertyState?: string;
}
const Termination = ({ propertyState }: Props) => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Default, Termination and Return of Deposits
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Where Buyer terminates this Agreement pursuant to any right granted by
          this Agreement, Buyer will be entitled to a return of all deposit
          monies paid on account of Purchase Price, and this Agreement will be
          VOID. Termination of this Agreement may occur for other reasons giving
          rise to claims by Buyer and/or Seller for the deposit monies.
        </li>
        <li>
          Regardless of the apparent entitlement to deposit monies,{' '}
          {propertyState} law does not allow a Broker holding deposit monies to
          determine who is entitled to the deposit monies when settlement does
          not occur. Broker can only release the deposit monies:
        </li>
        <ol className="list-decimal ml-6 space-y-1">
          <li>
            If this Agreement is terminated prior to settlement and there is no
            dispute over entitlement to the deposit monies. A written agreement
            signed by both parties is evidence that there is no dispute
            regarding deposit monies.
          </li>
          <li>
            If, after Broker has received deposit monies, Broker receives a
            written agreement that is signed by Buyer and Seller, directing
            Broker how to distribute some or all of the deposit monies.
          </li>
          <li>According to the terms of a final order of court.</li>
          <li>
            According to the terms of a prior written agreement between Buyer
            and Seller that directs the Broker how to distribute the deposit
            monies if there is a dispute between the parties that is not
            resolved.
          </li>
        </ol>
        <li>
          Buyer and Seller agree that if there is a dispute over the entitlement
          to deposit monies that is unresolved 30 days after the Settlement Date
          stated in this agreement (or any written extensions thereof) or
          following termination of the Agreement, whichever is earlier, then the
          Broker holding the deposit monies will, within 30 days of receipt of
          Buyer's written request, distribute the deposit monies to Buyer unless
          the Broker is in receipt of verifiable written notice that the dispute
          is the subject of litigation or mediation. If Broker has received
          verifiable written notice of litigation or mediation prior to the
          receipt of Buyer’s request for distribution, Broker will continue to
          hold the deposit monies until receipt of a written distribution
          agreement between Buyer and Seller or a final court order. Buyer and
          Seller are advised to initiate litigation or mediation for any portion
          of the deposit monies prior to any distribution made by Broker
          pursuant to this paragraph. Buyer and Seller agree that the
          distribution of deposit monies based upon the passage of time does not
          legally determine entitlement to deposit monies, and that the parties
          maintain their legal rights to pursue litigation even after a
          distribution is made.
        </li>
        <li>
          Buyer and Seller agree that a Broker who holds or distributes deposit
          monies pursuant to the terms of this agreement or {propertyState} law
          will not be liable. Buyer and Seller agree that if any Broker or
          affiliated licensee is named in litigation regarding deposit monies,
          the attorneys’ fees and costs of the Broker(s) and licensee(s) will be
          paid by the party naming them in litigation.
        </li>
        <li>
          Seller has the option of retaining all sums paid by Buyer, including
          the deposit monies, should Buyer:
        </li>
        <ol className="list-decimal ml-6 space-y-1">
          <li>Fail to make any payments as specified, OR</li>
          <li>
            Furnish false or incomplete information to Seller, Broker(s), or any
            other party identified in this Agreement concerning Buyer’s legal or
            financial status
          </li>
          <li>
            Violate or fail to fulfill and perform any other terms or conditions
            of this Agreement.
          </li>
        </ol>
        <li>
          Unless otherwise determined in this agreement, Seller may elect to
          retain those sums paid by Buyer, including deposit monies:
        </li>
        <ol className="list-decimal ml-6 space-y-1">
          <li>On account of purchase price, OR</li>
          <li>As monies to be applied to Seller’s damages, OR</li>
          <li>As liquidated damages for such default.</li>
        </ol>
        <li>
          Seller is limited to retaining sums paid by buyer, including deposit
          monies, as liquidated damanges.
        </li>
        <li>
          If Seller retains all sums paid by Buyer, including deposit monies, as
          liquidated damages, Buyer and Seller are released from further
          liability or obligation and this Agreement is VOID.
        </li>
        <li>Brokers and licensees are not responsible for unpaid deposits.</li>
      </ol>
    </div>
  );
};

export default Termination;
